

<app-embedded-video *ngIf="hasVideos"
[videoUrl]="videoUrl"
[query]="videoQuery"
[attr]="videoAttr">
</app-embedded-video>

<app-page-decoration *ngIf="hasPageDecoration && !facetsLoading"
[page]="page"
[type]="'catalog'">
</app-page-decoration>

<!-- breadcrumbs -->
<app-breadcrumbs
[crumbs]="crumbs"
*ngIf="showCrumbs">
</app-breadcrumbs>

<div id="filterTrigger"
   infinite-scroll
   infiniteScrollDistance="1"
   infiniteScrollThrottle="300"
   (scrolled)="expandProducts()"
   [ngClass]="{'container-fluid': fullWidthView$ | async, 'container': !(fullWidthView$ | async)}">

   <div class="row align-items-start">

    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 filter-column">

      <button class="d-block d-md-none btn btn-default btn-toggle-filterlist" (click)="toggleFilterList()"><i class="fa fa-filter"></i> Filter</button>

      <div id="filtersList" class="filter-wrapper" [ngClass]="{ 'active': showFilterList }">
        <app-only-in-stock class="in-stock"
                           *ngIf="catalogPageSettings?.showInStockToggle"
                           [enabled]="onlyStock"
                           (toggled)="inStockToggled()">
        </app-only-in-stock>

        <app-hierarchical-menu
          *ngIf="menuItems"
          [first]="true"
          [type]="'side'"
          [activeChain]="activeChain"
          [showArrows]="true"
          [ids]="sideMenuIds"
          [menuData]="menuItems">
          <ng-template let-menuId>
            <ng-template [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="{$implicit: menuId}"></ng-template>
          </ng-template>
        </app-hierarchical-menu>

        <app-filter-group
          *ngFor="let filterGroup of filterGroups"
          [groupName]="filterGroup.name"
          [filterItems]="filterGroup.filterItems"
          (filterToggled)="onFilterToggled($event)">
        </app-filter-group>

        <app-facetgroup-list
          [groups]="facets"
          [applied]="applied"
          [loading]="facetsLoading"
          [openGroups]="openGroups"
          (facetToggled)="facetToggled($event)"
          (groupToggled)="showMoreToggled($event)">
        </app-facetgroup-list>
      </div>

    </div>
    <div id="productsList" class="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-12 products">

      <!-- Page Title -->
      <div *ngIf="!hasPageDecoration && page.name" class="page-title">
        <h2>{{ page.name }}</h2>
      </div>

      <div class="row row-count-and-more" *ngIf="hasProducts">
        <div class="col-md-7 col-sm-7">
          <p class="products_count" *ngIf="!productsLoading">
            {{ totalProductCount }} {{ 'catalog.total-products' | translate }}
          </p>
        </div>

        <!-- SK 09/10 switched off here to check out different layout -->
        <!-- <div [ngClass]="{ 'col-md-7': !hasViewTypeChoice, 'col-md-5': hasViewTypeChoice }">
            <app-chip-list [chips]="chips" (toggled)="facetToggled($event)">
            </app-chip-list>
          </div>
        -->

        <!-- <div class="right-aligned" [ngClass]="{ 'col-md-7': !hasViewTypeChoice, 'col-md-5 col-sm-5': hasViewTypeChoice }"> -->
        <div class="right-aligned col-md-5 col-sm-5">
          <div *ngIf="hasSortOrders" class="sort">
            {{ 'catalog.sort-by' | translate }}
            <select (change)="onSortOrderSelect($event)" [value]="sortOrder">
              <option *ngFor="let sortOrder of catalogSortOrders" [value]="sortOrder.key">
                {{ sortOrder.value | translate }}
              </option>
            </select>
          </div>

          <app-view-type-switch *ngIf="hasViewTypeChoice" [viewType]="viewType" (onTypeSwitched)="switchType($event)"
            (onToggleFullWidthView)="toggleFullWidthView($event)">
          </app-view-type-switch>
        </div>
      </div> <!-- // row-count-and-more -->

      <!--<div class="row">
          <div class="col-md-12">
              <app-chip-list [chips]="chips" (toggled)="facetToggled($event)">
              </app-chip-list>
            </div>
      </div>-->

      <app-products
        [cartProducts]="cartProducts"
        [favoritesProducts]="favoritesProducts"
        [catalogItemPageSettings]="catalogItemPageSettings"
        [combinedFacets]="combinedFacets"
        [products]="products"
        [loading]="productsLoading || productsExpanding"
        [loaded]="loaded"
        [viewType]="viewType"
        [quantityPicker]="quantityPicker"
        [allowOutOfStockOrdering]="allowOutOfStockOrdering"
        (onDetails)="openDetails($event)"
        (onFavoriteToggle)="toggleFavorite($event)"
        (onAddCart)="addCart($event)">
      </app-products>
    </div>

  </div>

  <!-- SK: work in progress
  <div class="resultcount-filter-and-sorting">
    <div class="resultcount">
      585 resultaten
    </div>
    <div class="filter-and-sorting">
      <button class="toggle-facets" onclick="">
        <i class="fa fa-filter" aria-hidden="true"></i> Filters
      </button>
      <span class="divider">|</span>
      <button class="toggle-sorting">
        <i class="fa fa-sort" aria-hidden="true"></i> Sorting
      </button>
    </div>
  </div>



<div>
-->
